const actionTypes = {
    ADD_USER_DATA: 'ADD_USER_DATA',
    CLEAR_USER_DATA: 'CLEAR_USER_DATA',
    ADD_UPDATE_USER_DATA: 'ADD_UPDATE_USER_DATA',
    ADD_REGISTER_USER: 'ADD_REGISTER_USER',
    RESET_PASSWORD: 'RESET_PASSWORD'
};

export { actionTypes };
